import { CouncilMeetingType } from "../../types/limited-company-creation/councilMeetingType"

export const councilMeetingInitialState: CouncilMeetingType = {
    meetingDate: ""
}